module.exports = __webpack_public_path__ + "images/marketing/bedrockdata-integration.png";